export const getMoreAvatars = avatars => {
  const isMoreAvatar = avatars.length > 10;
  const moreLength = avatars.length - 9;
  const displayAvatars = isMoreAvatar ? avatars.slice(0, 9) : avatars;
  return { isMoreAvatar, moreLength, displayAvatars };
};
